import { createContext, useContext } from 'react';

type OverrideAppContextValue = {
  getSonarUrlFromId?: (id: string) => string;
};
export const OverrideAppContext = createContext<OverrideAppContextValue>({});
export const OverrideAppContextProvider = OverrideAppContext.Provider;
export const useOverrideAppContext = () => useContext(OverrideAppContext);
